import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './config/i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "mobx-react";
import UiStore from "./stores/UiStore";
import CampaignStore from "./stores/CampaignStore";
import MenusStore from "./stores/Menu/MenusStore";
import TemplatesStore from "./stores/TemplateStore";
import MenusApi from "./stores/Menu/MenusApi";
import {WpexApi} from "./api/WpexApi";
import {SnackbarProvider} from "notistack";

const api = new WpexApi();
const templateStore = new TemplatesStore();
const uiStore = new UiStore(api);
const campaignStore = new CampaignStore(templateStore, uiStore, api);
const menuApi: MenusApi = new MenusApi();
const menuStore = new MenusStore(menuApi);
const stores = {
    campaignStore,
    uiStore,
    menuStore,
    templateStore,
    api,
};

if (process.env.NODE_ENV !== 'production') {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React);
}

ReactDOM.render(
    <SnackbarProvider hideIconVariant={false}
                      anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                      }}>
        <Provider {...stores}>
            <App/>
        </Provider>
    </SnackbarProvider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
